/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./partner-info.vue?vue&type=template&id=603e4913&scoped=true&"
import script from "./partner-info.vue?vue&type=script&lang=ts&"
export * from "./partner-info.vue?vue&type=script&lang=ts&"
import style0 from "./partner-info.vue?vue&type=style&index=0&id=603e4913&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603e4913",
  null
  
)

export default component.exports